module["exports"] = ["be", "brussels", "vlaanderen", "com", "net", "org"];